import { render, staticRenderFns } from "./safe.vue?vue&type=template&id=7ffa1626&"
import script from "./safe.vue?vue&type=script&lang=js&"
export * from "./safe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ffa1626')) {
      api.createRecord('7ffa1626', component.options)
    } else {
      api.reload('7ffa1626', component.options)
    }
    module.hot.accept("./safe.vue?vue&type=template&id=7ffa1626&", function () {
      api.rerender('7ffa1626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personalCenter/components/safe.vue"
export default component.exports